(function() {
//   console.log("Script loaded, waiting 5 seconds...");
  
  setTimeout(function() {
    // console.log("5 seconds passed, initializing...");
    init();
  }, 6000);

  function init() {
    // console.log("=== Starting initialization ===");
    
    const qtyInput = document.getElementById("custom_bhoopi_new_custom-quantity");
    const increaseBtn = document.getElementById("custom_bhoopi_new_custom-increase");
    const decreaseBtn = document.getElementById("custom_bhoopi_new_custom-decrease");
    const variantSelect = document.querySelector(".custom_bhoopi_new_custom-variant-select");
    const hiddenVariantId = document.getElementById("custom_bhoopi_new_custom-variant-id");
    
    // Debug: Check if elements are found
    // console.log("=== Element Check ===");
    // console.log("qtyInput found:", !!qtyInput, qtyInput);
    // console.log("increaseBtn found:", !!increaseBtn, increaseBtn);
    // console.log("decreaseBtn found:", !!decreaseBtn, decreaseBtn);
    // console.log("variantSelect found:", !!variantSelect, variantSelect);
    // console.log("hiddenVariantId found:", !!hiddenVariantId, hiddenVariantId);
    
    if (!variantSelect || !hiddenVariantId || !qtyInput) {
    //   console.error("❌ Required elements not found! Stopping initialization.");
      return;
    }
    
    // console.log("✅ All required elements found!");
    
    // Set initial value from the select dropdown
    hiddenVariantId.value = variantSelect.value;
    // console.log("📦 Initial variant ID set to:", hiddenVariantId.value);
    
    // Update hidden variant ID when select changes
    variantSelect.addEventListener("change", function() {
    //   console.log("🔄 Variant select changed");
    //   console.log("  Old value:", hiddenVariantId.value);
      hiddenVariantId.value = this.value;
    //   console.log("  New value:", hiddenVariantId.value);
    });
    console.log("✅ Variant change listener added");
    
    // Quantity increase
    if (increaseBtn) {
      increaseBtn.addEventListener("click", function(e) {
        e.preventDefault();
        const oldVal = qtyInput.value;
        const currentVal = parseInt(qtyInput.value) || 1;
        qtyInput.value = currentVal + 1;
        // console.log("➕ Quantity increased:", oldVal, "→", qtyInput.value);
      });
    //   console.log("✅ Increase button listener added");
    } else {
    //   console.warn("⚠️ Increase button not found");
    }
    
    // Quantity decrease (not below 1)
    if (decreaseBtn) {
      decreaseBtn.addEventListener("click", function(e) {
        e.preventDefault();
        const oldVal = qtyInput.value;
        const currentVal = parseInt(qtyInput.value) || 1;
        if (currentVal > 1) {
          qtyInput.value = currentVal - 1;
          console.log("➖ Quantity decreased:", oldVal, "→", qtyInput.value);
        } else {
          console.log("⚠️ Cannot decrease below 1");
        }
      });
    //   console.log("✅ Decrease button listener added");
    } else {
    //   console.warn("⚠️ Decrease button not found");
    }
    
    // Prevent non-numeric input in quantity field
    qtyInput.addEventListener("input", function() {
      if (this.value < 1 || this.value === '') {
        // console.log("⚠️ Invalid quantity detected, resetting to 1");
        this.value = 1;
      }
    });
    // console.log("✅ Quantity input validation added");
    
    // console.log("=== ✅ Initialization complete ===");
  }
})();


document.addEventListener('DOMContentLoaded', function() {
  var tweetsSlider = document.querySelector('.tweet_slide_main');
  if (tweetsSlider && typeof Flickity !== 'undefined') {
    // Apply CSS dynamically so each slide takes 50% width
    var style = document.createElement('style');
    style.innerHTML = `
      .tweet_slide_main .tweet_slide_inner {
        width: 50%;
        padding: 10px;
        box-sizing: border-box;
      }
      @media (max-width: 768px) {
        .tweet_slide_main .tweet_slide_inner {
          width: 70%;
        }
      }
    `;
    document.head.appendChild(style);

    new Flickity(tweetsSlider, {
      cellAlign: 'left',
      contain: true,
      pageDots: true,
      prevNextButtons: false,
      wrapAround: true,
      autoPlay: false,
      // pauseAutoPlayOnHover: true,
      draggable: true,
      imagesLoaded: true
    });
  } else {
    console.error('Flickity not found or container missing.');
  }


















   var tweetsSlider = document.querySelector('.tweet_slide_main_bhoopi');
  if (tweetsSlider && typeof Flickity !== 'undefined') {
    // Apply CSS dynamically so each slide takes 50% width
    var style = document.createElement('style');
    style.innerHTML = `
      .tweet_slide_main_bhoopi .tweet_slide_inner_bhoopi {
        width: 20%;
        padding: 10px;
        box-sizing: border-box;
      }
      @media (max-width: 768px) {
        .tweet_slide_main_bhoopi .tweet_slide_inner_bhoopi {
          width: 70%;
        }
      }
    `;
    document.head.appendChild(style);

    new Flickity(tweetsSlider, {
      cellAlign: 'left',
      contain: true,
      pageDots: true,
      prevNextButtons: false,
      wrapAround: true,
      autoPlay: false,
      // pauseAutoPlayOnHover: true,
      draggable: true,
      imagesLoaded: true
    });
  } else {
    console.error('Flickity not found or container missing.');
  }








    var awardsSlider = document.querySelector('.award_slide_main');
  if (awardsSlider && typeof Flickity !== 'undefined') {
    // Apply CSS dynamically so each slide takes 50% width
    var style = document.createElement('style');
    style.innerHTML = `
      .award_slide_main .award_slide_inner {
        width: 50%;
        padding: 10px;
        box-sizing: border-box;
      }
         @media (max-width: 768px) {
        .award_slide_main .award_slide_inner {
          width: 70%;
        }
      }
    `;
    document.head.appendChild(style);

    new Flickity(awardsSlider, {
      cellAlign: 'left',
      contain: true,
      pageDots: true,
      prevNextButtons: false,
      wrapAround: true,
      autoPlay: false,
      // pauseAutoPlayOnHover: true,
      draggable: true,
      imagesLoaded: true
    });
  } else {
    console.error('Flickity not found or container missing.');
  }





  //  var expertSlider = document.querySelector('.expert_slide_main');
  // if (expertSlider && typeof Flickity !== 'undefined') {
  //   // Apply CSS dynamically so each slide takes 50% width
  //   var style = document.createElement('style');
  //   style.innerHTML = `
  //     .expert_slide_main .expert_slide_inner {
  //       width: 50%;
  //       padding: 10px;
  //       box-sizing: border-box;
  //     }
  //        @media (max-width: 768px) {
  //       .expert_slide_main .expert_slide_inner {
  //         width: 100%;
  //       }
  //     }
  //   `;
  //   document.head.appendChild(style);

  //   new Flickity(expertSlider, {
  //     cellAlign: 'left',
  //     contain: true,
  //     pageDots: true,
  //     prevNextButtons: false,
  //     wrapAround: true,
  //     autoPlay: 2000,
  //     pauseAutoPlayOnHover: true,
  //     draggable: true,
  //     imagesLoaded: true
  //   });
  // } else {
  //   console.error('Flickity not found or container missing.');
  // }




  document.querySelectorAll('.product_drop_down_custom_bhoopi_inner_blocks').forEach(block => {
  block.addEventListener('click', () => {
    const parent = block.closest('.product_drop_down_custom_bhoopi_inner');
    parent.classList.toggle('active');
  });
});



document.querySelectorAll('.vrw-tweet-text.readmore_button').forEach(function(button) {
  button.addEventListener('click', function() {
    // Remove active class from all target elements
    document.querySelectorAll('.tweets_custom_bs_bhoopi_inner_block.award.expert_slide_inner.active')
      .forEach(el => el.classList.remove('active'));
    
    // Find the closest parent and add active
    const parent = button.closest('.tweets_custom_bs_bhoopi_inner_block.award.expert_slide_inner');
    if (parent) {
      parent.classList.add('active');
    }

    // Add class to body
    document.body.classList.add('active_bs');
  });
});




document.querySelectorAll('.close_popfbnjhbjgjg').forEach(function(button) {
  button.addEventListener('click', function() {
    // Remove active class from all target elements
    document.querySelectorAll('.tweets_custom_bs_bhoopi_inner_block.award.expert_slide_inner.active')
      .forEach(el => el.classList.remove('active'));
       document.body.classList.remove('active_bs');
    
  });
});




});


document.addEventListener('DOMContentLoaded', () => {
  const questions = document.querySelectorAll('#faq-accordion .faq-question');

  // Ensure the first has correct transition feel
  const firstAns = document.querySelector('#faq-accordion .faq-answer.show');
  if (firstAns) {
    firstAns.style.transition = "height 0.28s ease, opacity 0.28s ease";
  }

  const closeAll = (exceptId) => {
    questions.forEach(q => {
      const targetSel = q.getAttribute('data-bs-target');
      const panel = document.querySelector(targetSel);
      if (!panel) return;
      if (targetSel !== exceptId && panel.classList.contains('show')) {
        panel.classList.remove('show');
        q.setAttribute('aria-expanded', 'false');
      }
    });
  };

  const togglePanel = (q) => {
    const targetSel = q.getAttribute('data-bs-target');
    const panel = document.querySelector(targetSel);
    if (!panel) return;

    // Accordion behavior: close others first
    closeAll(targetSel);

    // Toggle clicked one
    panel.classList.toggle('show');
    const isOpen = panel.classList.contains('show');
    q.setAttribute('aria-expanded', String(isOpen));
  };

  questions.forEach(q => {
    q.addEventListener('click', () => togglePanel(q));

    // Keyboard support (Enter/Space)
    q.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        togglePanel(q);
      }
    });
  });
});






